export const API_SERVER =
  "https://wanzam-backend-4cme6d834-franks-projects-d94b555b.vercel.app";
